import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-77ddce8c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "UpgradeVoices"
};
var _hoisted_2 = {
  "class": "modal"
};
var _hoisted_3 = {
  "class": "modal-content"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "encouragement",
    style: {
      "margin-top": "20px"
    }
  }, "PRO Voices Preview Has Ended", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "modal-summary"
  }, " You've been using the app's PRO voices so far but now you'll be hearing the standard voices which are still pretty good. ", -1);
});
var _hoisted_6 = {
  "class": "highlight"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "modal-summary note",
    style: {
      "margin-top": "10px"
    }
  }, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("b", null, "Why did the voices change?")]), /*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin-top": "10px"
    }
  }, "Believe it or not, voices cost us money to use and we're on a tight budget")], -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!_ctx.success ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: "times",
    "class": "close-icon",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$store.commit('updateUpgradeVoicesScreen', false);
    })
  })) : _createCommentVNode("", true), _hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_createTextVNode("We would love for you to upgrade to pro today to get all the benefits of PRO including the PRO Voices! "), _createElementVNode("button", {
    "class": "review-button",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      _ctx.$store.commit('updateUpgradeVoicesScreen', false);
      _ctx.$store.commit('updateShowUpgradeMembershipPage', true);
    }),
    style: {
      "margin-top": "20px"
    }
  }, "Upgrade to PRO")]), _hoisted_7])])]);
}